export const LEADS_INFO = {
  lob: 'Animais Dom�sticos',
}
